import { Router } from "./router/router";

export class App {
  private router: Router;

  constructor() {
    const container = document.getElementById("app");
    if (!container) throw new Error("Root container not found");

    this.router = new Router(
      container,
      { path: "/404", pageName: "notfound" },
      { path: "/login", pageName: "login" },
      // Replace this with your actual checkLoggedIn function
      // async () => this.store.getState().user.isAuthenticated
    );

    this.initializeRoutes();

    // Make router accessible globally for navigation
    (window as any).appRouter = this.router;
  }

  private initializeRoutes(): void {
    this.router.addRoute({ path: "/", pageName: "home", protected: true });
    this.router.addRoute({ path: "/login", pageName: "login", protected: false });
    this.router.addRoute({ path: "/register", pageName: "register", protected: false });
    this.router.addRoute({ path: "/profile", pageName: "profile", protected: true });
    this.router.addRoute({ path: "/profiler", pageName: "profiler", protected: true });
  }

  start(): void {
    this.router.init();
  }
}
